import { useCallback, useEffect, useState } from "react";
import { useDispatch, useStore } from "react-redux";
import { fetchLieferadressen } from "../reducers/lieferadressen-reducer";
import { Form, Spinner } from "react-bootstrap";
import LieferadressenTable from "./LieferadressenTable";

const Lieferadressen = () => {
  const { rightStorage, configStorage, lieferadressenStorage } = useStore().getState();
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  const canOpenLieferadressen = rightStorage.isAdmin() || configStorage.isBLBAdmin();
  const isReadOnlyForRole = !rightStorage.isAdmin();

  const labels = {
    edelmetall: "Edelmetalle",
    sorten: "Sorten",
    bezeichnung: "Bezeichnung",
    lieferadressenNummer: "ID",
    shops: "Shop",
    bezeichnungOnline: "Online",
    bezeichnungStationaer: "Stationär",
    edelmetallMaxBetrag: "Maximaler Betrag",
    lieferbar: "Lieferbar",
    edelmetallLieferbarKzBerater: "Beratershop",
    edelmetallLieferbarKzKunde: "Kundenshop",
    sortenMaxBetrag: "Maximaler Betrag",
    sortenLieferbarKzBerater: "Beratershop",
    sortenLieferbarKzKunde: "Kundenshop",
    Berater: "Beratershop",
    Kunde: "Kundenshop",
  };

  const loadData = useCallback(async () => {
    if (lieferadressenStorage.isLoading()) return;
    const apiCall = configStorage.getApiRequest("lieferadressen");
    let res;
    try {
      res = await Promise.resolve(dispatch(fetchLieferadressen({ apiCall })));
    } catch (e) {
      console.error(e);
      setError(e.message);
      return;
    }
    setLoaded(true);
    if (!res || res.type === "lieferadressen/fetchLieferadressen/rejected") {
      setError(res.error || "Daten konten nicht geladen werden");
      return;
    }
    setError(null);
  }, [configStorage, dispatch, lieferadressenStorage]);

  useEffect(() => {
    if (!loaded && canOpenLieferadressen) {
      loadData();
    }
  }, [canOpenLieferadressen, loadData, loaded]);

  const onSubmit = useCallback((e) => {
    return;
  }, []);

  if (!canOpenLieferadressen) {
    return null;
  }
  if (lieferadressenStorage.isLoading()) {
    return <div>
      <h1>Lieferadressen</h1>
      <Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>;
  }
  if (!lieferadressenStorage.hasData()) {
    return loaded
      ? <div>
        <h1>Lieferadressen</h1>
        <div className="alert alert-danger fs-6 p-1">Es konnten keine Lieferadressen geladen werden</div>
      </div>
      : null;
  }

  return <div className="lieferadressen" >
    <Form onSubmit={onSubmit}>
      <h1>Lieferadressen</h1>
      {error || lieferadressenStorage.getError()
        ? <div className="alert alert-danger fs-6 p-1">{error || lieferadressenStorage.getError()}</div>
        : null
      }
      <LieferadressenTable labels={labels} readOnly={isReadOnlyForRole} />
    </Form>
  </div>;
};

export default Lieferadressen;
